import { jsx as m, jsxs as C, Fragment as M } from "react/jsx-runtime";
import { c as O } from "react/compiler-runtime";
import { Box as D, TableContainer as X, Table as k } from "@mui/material";
import { T as q, u as A } from "../../../chunks/TableContext.js";
import { TableBody as G } from "./TableBody.js";
import { TableHeader as I } from "./TableHeader.js";
import { TableFooter as J } from "./TableFooter.js";
import { styles as K } from "./styles.js";
import { TableSearchBar as N } from "./TableSearchBar.js";
import { ColumnVisibilityToggle as Q } from "./ColumnVisibilityToggle.js";
import { useRef as U, useState as Y, useEffect as Z } from "react";
const ee = () => {
  const t = O(9), {
    table: e,
    isLoading: f
  } = A(), a = e.getRowCount() === 0 && !f ? "100%" : "auto";
  let o;
  t[0] !== a ? (o = {
    height: a
  }, t[0] = a, t[1] = o) : o = t[1];
  let l, r;
  t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ m(I, {}), r = /* @__PURE__ */ m(G, {}), t[2] = l, t[3] = r) : (l = t[2], r = t[3]);
  let i;
  t[4] !== o ? (i = /* @__PURE__ */ C(k, { "aria-label": "flexible table", sx: o, children: [
    l,
    r
  ] }), t[4] = o, t[5] = i) : i = t[5];
  let n;
  t[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m(J, {}), t[6] = n) : n = t[6];
  let s;
  return t[7] !== i ? (s = /* @__PURE__ */ C(M, { children: [
    i,
    n
  ] }), t[7] = i, t[8] = s) : s = t[8], s;
};
function he(t) {
  const e = O(46);
  let f, a, o, l, r, i, n, s, c;
  e[0] !== t ? ({
    width: c,
    height: a,
    minWidth: i,
    maxWidth: l,
    minHeight: r,
    maxHeight: o,
    enableVirtualization: s,
    data: f,
    ...n
  } = t, e[0] = t, e[1] = f, e[2] = a, e[3] = o, e[4] = l, e[5] = r, e[6] = i, e[7] = n, e[8] = s, e[9] = c) : (f = e[1], a = e[2], o = e[3], l = e[4], r = e[5], i = e[6], n = e[7], s = e[8], c = e[9]);
  const h = s === void 0 ? !1 : s, p = U(null), [w, P] = Y(0);
  let _, T;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (_ = () => {
    const F = () => {
      if (p.current) {
        const E = p.current.offsetHeight;
        P(E);
      }
    };
    F();
    const L = new ResizeObserver(F);
    return p.current && L.observe(p.current), () => {
      L.disconnect();
    };
  }, T = [], e[10] = _, e[11] = T) : (_ = e[10], T = e[11]), Z(_, T);
  let y;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    position: "relative"
  }, e[12] = y) : y = e[12];
  let S;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (S = {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    height: "100%"
  }, e[13] = S) : S = e[13];
  let H;
  e[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (H = /* @__PURE__ */ m(D, { ref: p, children: /* @__PURE__ */ m(N, {}) }), e[14] = H) : H = e[14];
  const z = a || "100%", R = r || "auto", W = o || "auto", V = h ? "auto" : void 0, $ = h || l ? "fixed" : "auto", j = h || l ? "max-content" : "100%";
  let b;
  e[15] !== $ || e[16] !== j ? (b = {
    tableLayout: $,
    width: j,
    minWidth: "100%"
  }, e[15] = $, e[16] = j, e[17] = b) : b = e[17];
  let u;
  e[18] !== l || e[19] !== i || e[20] !== V || e[21] !== b || e[22] !== z || e[23] !== R || e[24] !== W || e[25] !== c ? (u = {
    ...K.tableContainer,
    width: c,
    height: z,
    minHeight: R,
    maxHeight: W,
    minWidth: i,
    maxWidth: l,
    overflowX: V,
    "& .MuiTable-root": b,
    boxSizing: "border-box"
  }, e[18] = l, e[19] = i, e[20] = V, e[21] = b, e[22] = z, e[23] = R, e[24] = W, e[25] = c, e[26] = u) : u = e[26];
  let v;
  e[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = /* @__PURE__ */ m(ee, {}), e[27] = v) : v = e[27];
  let d;
  e[28] !== u ? (d = /* @__PURE__ */ C(D, { sx: S, children: [
    H,
    /* @__PURE__ */ m(X, { sx: u, id: "table-container", children: v })
  ] }), e[28] = u, e[29] = d) : d = e[29];
  let x;
  e[30] !== w ? (x = /* @__PURE__ */ m(Q, { searchBarHeight: w }), e[30] = w, e[31] = x) : x = e[31];
  let g;
  e[32] !== d || e[33] !== x ? (g = /* @__PURE__ */ C(D, { sx: y, children: [
    d,
    x
  ] }), e[32] = d, e[33] = x, e[34] = g) : g = e[34];
  let B;
  return e[35] !== f || e[36] !== h || e[37] !== a || e[38] !== o || e[39] !== l || e[40] !== r || e[41] !== i || e[42] !== n || e[43] !== g || e[44] !== c ? (B = /* @__PURE__ */ m(q, { width: c, height: a, minWidth: i, maxWidth: l, minHeight: r, maxHeight: o, enableVirtualization: h, data: f, ...n, children: g }), e[35] = f, e[36] = h, e[37] = a, e[38] = o, e[39] = l, e[40] = r, e[41] = i, e[42] = n, e[43] = g, e[44] = c, e[45] = B) : B = e[45], B;
}
export {
  he as Table
};
